/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const getPathnameFromAsPath = (asPath: string): string => {
  return asPath.split(/[?#]/)[0];
};
